






import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "poke-type-badge"
})
export default class PokeTypeBadge extends Vue {
  @Prop()
  type!: string;

  get bgColor(): string {
    return `-${this.type}background`;
  }

  get translatedType(): string {
    return this.$t(`shared.pokemonTypes.${this.type}`).toString();
  }
}
